import api from '../../api.js';

export const BreadcrumbSelector = {
  BREADCRUMB: api.internals.ns.selector('breadcrumb')
};
